import { useAuthStore } from '@/store/auth'

import { GtmEvent } from '@/types/gtm'

export function useAttribution(nuxtApp = useNuxtApp()) {
  const route = useRoute()
  const siteIdSession = useSiteIdStorage()

  const authStore = useAuthStore()

  tryOnMounted(() => {
    const siteId = route.query.site_id as string
    if (siteId) {
      siteIdSession.value = siteId
    }

    if (authStore.isLogin && siteIdSession.value) {
      nuxtApp.$trackEvent({
        event: GtmEvent.SMART_LINK_TRIGGERED,
        payload: {
          site_id: siteIdSession.value,
        },
      })
    }
  })
}
